function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 10.75a.75.75 0 01.75.75v10.645a2 2 0 11-1.5 0V11.5a.75.75 0 01.75-.75zm0 13.75a.5.5 0 100-1 .5.5 0 000 1z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 1a4.5 4.5 0 00-4.5 4.5v13.138a7 7 0 109 0V5.5A4.5 4.5 0 0016 1zm-2.5 4.5a2.5 2.5 0 015 0v13.626a1 1 0 00.416.812 5 5 0 11-5.832 0 1 1 0 00.416-.812V5.5z",
  fill: "currentColor"
})));